import { DEFAULT_RETRY_INTERVAL } from '../data-types/timing/timingConstants';
import {
  TWITTER_PIXEL_COMPLETE_REGISTRATION_KEY,
  TWITTER_PIXEL_DEPOSIT_KEY,
  TWITTER_PIXEL_ENABLED,
  TWITTER_PIXEL_FIRST_DEPOSIT_KEY,
  TWITTER_PIXEL_LOGIN_KEY,
  TWITTER_PIXEL_PAGE_VIEW_KEY,
  TWITTER_PIXEL_START_REGISTRATION_KEY,
} from '../initialisation/initialisation';

export interface TwitterPixelPayload {
  conversion_id: string | null;
  value?: number | null;
  email_address?: string | null;
}

enum TwitterPixelRequestType {
  EVENT = 'event',
}

const waitUntilTwqIsDefined = (callback: () => void) => {
  const maxTrials = 10;
  let trials = 0;
  const interval = setInterval(() => {
    if (trials === maxTrials) {
      clearInterval(interval);
    }

    if (!!window.twq) {
      callback();
      clearInterval(interval);
    }
    trials += 1;
  }, DEFAULT_RETRY_INTERVAL);
};

const trackDeposit = (conversionId: string | null, value: number | null) => () => {
  window.twq(TwitterPixelRequestType.EVENT, TWITTER_PIXEL_DEPOSIT_KEY || '', {
    value,
    conversion_id: conversionId,
  });
};

const trackFirstDeposit = (conversionId: string | null, value: number | null) => () => {
  window.twq(TwitterPixelRequestType.EVENT, TWITTER_PIXEL_FIRST_DEPOSIT_KEY || '', {
    value,
    conversion_id: conversionId,
  });
};

const completeRegistration = (conversionId: string | null) => () => {
  window.twq(TwitterPixelRequestType.EVENT, TWITTER_PIXEL_COMPLETE_REGISTRATION_KEY || '', {
    conversion_id: conversionId,
  });
};

const startRegistration = (conversionId: string | null) => () => {
  window.twq(TwitterPixelRequestType.EVENT, TWITTER_PIXEL_START_REGISTRATION_KEY || '', {
    conversion_id: conversionId,
  });
};

const login = (conversionId: string | null, email: string | null) => () => {
  window.twq(TwitterPixelRequestType.EVENT, TWITTER_PIXEL_LOGIN_KEY || '', {
    conversion_id: conversionId,
    email_address: email,
  });
};

const pageView = (conversionId: string | null) => () => {
  window.twq(TwitterPixelRequestType.EVENT, TWITTER_PIXEL_PAGE_VIEW_KEY || '', {
    conversion_id: conversionId,
  });
};

export const twitterPixelTrackDeposit = (conversionId: string | null, value: number | null) => {
  if (TWITTER_PIXEL_ENABLED && TWITTER_PIXEL_DEPOSIT_KEY) {
    waitUntilTwqIsDefined(trackDeposit(conversionId, value));
  }
};

export const twitterPixelTrackFirstDeposit = (conversionId: string | null, value: number | null) => {
  if (TWITTER_PIXEL_ENABLED && TWITTER_PIXEL_FIRST_DEPOSIT_KEY) {
    waitUntilTwqIsDefined(trackFirstDeposit(conversionId, value));
  }
};

export const twitterPixelTrackFinishRegistration = (conversionId: string | null) => {
  if (TWITTER_PIXEL_ENABLED && TWITTER_PIXEL_COMPLETE_REGISTRATION_KEY) {
    waitUntilTwqIsDefined(completeRegistration(conversionId));
  }
};

export const twitterPixelTrackStartRegistration = (conversionId: string | null) => {
  if (TWITTER_PIXEL_ENABLED && TWITTER_PIXEL_START_REGISTRATION_KEY) {
    waitUntilTwqIsDefined(startRegistration(conversionId));
  }
};

export const twitterPixelTrackLogin = (conversionId: string | null, email: string | null) => {
  if (TWITTER_PIXEL_ENABLED && TWITTER_PIXEL_LOGIN_KEY) {
    waitUntilTwqIsDefined(login(conversionId, email));
  }
};

export const twitterPixelTrackPageView = (conversionId: string | null) => {
  if (TWITTER_PIXEL_ENABLED && TWITTER_PIXEL_PAGE_VIEW_KEY) {
    waitUntilTwqIsDefined(pageView(conversionId));
  }
};
